import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import OrderEntityForm from 'components/forms/settings/OrderEntityForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import './OrderEntityDrawer.css';
var OrderEntityDrawer = function (props) {
    var _a, _b;
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, orderEntity = props.orderEntity, translate = props.translate, isEdit = props.isEdit;
    var _c = useState(false), saving = _c[0], setSaving = _c[1];
    var onClose = function () { return onCloseDrawer(); };
    var orderEntityService = services.orderEntityService;
    var createEntity = orderEntityService.useCreateOrderEntity().mutate;
    var updateEntity = orderEntityService.useUpdateOrderEntity().mutate;
    var onSubmit = function () {
        if (!orderEntity || saving)
            return;
        setSaving(true);
        var payload = {
            orderEntity: orderEntity,
            successMessage: isEdit
                ? translate('orderEntities.messages.updated')
                : translate('orderEntities.messages.created')
        };
        var onSuccess = function () {
            setSaving(false);
            onClose();
        };
        var onError = function () { return setSaving(false); };
        if (!isEdit) {
            createEntity(payload, { onSuccess: onSuccess, onError: onError });
        }
        else {
            updateEntity(payload, { onSuccess: onSuccess, onError: onError });
        }
    };
    var formKey = "order-entity-form-".concat((_a = orderEntity === null || orderEntity === void 0 ? void 0 : orderEntity.getId()) !== null && _a !== void 0 ? _a : 0, "-").concat(Number(visiable));
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onClose, closable: false, destroyOnClose: true, width: 440, rootClassName: "order-entity-drawer", className: "order-entity-drawer", children: _jsxs(Form, { layout: "vertical", className: "order-entity-drawer__shell", requiredMark: false, onFinish: onSubmit, onValuesChange: function (changed) {
                var _a, _b;
                if (!orderEntity)
                    return;
                if (Object.prototype.hasOwnProperty.call(changed, 'name')) {
                    orderEntity.setName((_a = changed.name) !== null && _a !== void 0 ? _a : '');
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'code')) {
                    orderEntity.setCode((_b = changed.code) !== null && _b !== void 0 ? _b : '');
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'entity_type')) {
                    orderEntity.setEntityType(String(changed.entity_type));
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'is_enabled')) {
                    orderEntity.setEnabled(Boolean(changed.is_enabled));
                }
            }, initialValues: {
                name: (orderEntity === null || orderEntity === void 0 ? void 0 : orderEntity.getName()) || '',
                code: (orderEntity === null || orderEntity === void 0 ? void 0 : orderEntity.getCode()) || '',
                entity_type: (orderEntity === null || orderEntity === void 0 ? void 0 : orderEntity.getEntityType()) || undefined,
                is_enabled: (_b = orderEntity === null || orderEntity === void 0 ? void 0 : orderEntity.isEnabled()) !== null && _b !== void 0 ? _b : true
            }, children: [_jsxs("header", { className: "order-entity-drawer__header", children: [_jsxs("div", { className: "order-entity-drawer__title-block", children: [_jsx("span", { className: "order-entity-drawer__dot", "aria-hidden": true }), _jsxs("div", { children: [_jsx("h2", { className: "order-entity-drawer__title", children: isEdit
                                                ? translate('orderEntities.drawers.editTitle')
                                                : translate('orderEntities.drawers.addTitle') }), _jsx("p", { className: "order-entity-drawer__subtitle", children: isEdit
                                                ? translate('orderEntities.drawers.editSubtitle')
                                                : translate('orderEntities.drawers.addSubtitle') })] })] }), _jsx("button", { type: "button", className: "order-entity-drawer__close", onClick: onClose, "aria-label": translate('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsxs("div", { className: "order-entity-drawer__body", children: [orderEntity ? _jsx(OrderEntityForm, { orderEntity: orderEntity, mode: isEdit ? 'edit' : 'create' }) : null, _jsxs("p", { className: "order-entity-drawer__note", children: [_jsxs("strong", { children: [translate('orderEntities.drawers.noteLabel'), " "] }), translate('orderEntities.drawers.note')] })] }), _jsxs("footer", { className: "order-entity-drawer__footer", children: [_jsx("button", { type: "button", className: "order-entity-drawer__btn order-entity-drawer__btn--ghost", onClick: onClose, children: translate('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "order-entity-drawer__btn order-entity-drawer__btn--primary", disabled: saving || !orderEntity, children: [_jsx(CheckOutlined, {}), _jsx("span", { children: saving
                                        ? translate('orderEntities.drawers.saving')
                                        : translate('orderEntities.drawers.save') })] })] })] }, formKey) }));
};
export default localeTranslator(OrderEntityDrawer, 'settings');
